import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import { Clock } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import { SsoTestIds } from '../../../../utils/testIds/Sso.testIds';
import { useTranslation } from '../../../translation/TranslationContext';

interface SsoReauthModalProps {
  isOpen: boolean;
  minutesRemaining: number;
  onClose: () => void;
  onReauthenticate: () => void;
}

const SsoReauthModal = ({
  isOpen,
  minutesRemaining,
  onClose,
  onReauthenticate,
}: SsoReauthModalProps) => {
  const { translate } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="compact"
      testId={SsoTestIds.REAUTH_MODAL}
      onClose={onClose}
      header={{ title: LangEnum.SSO_REAUTH_WARNING_TITLE, icon: Clock }}
      footer={{
        primaryAction: {
          label: LangEnum.SSO_REAUTH_WARNING_ACTION,
          testId: SsoTestIds.REAUTH_MODAL_ACTION,
          onClick: onReauthenticate,
        },
      }}
    >
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {translate(LangEnum.SSO_REAUTH_WARNING_MESSAGE, { minutes: minutesRemaining })}
      </Typography>
    </Modal>
  );
};

export default SsoReauthModal;
